<template>
    <div class="bg-white mt-3 progress-status-view activity-type-create col-12" :style="themeColor">
        
        <b-row>
            <b-col md="6" cols="12" class="mt-3 dd" v-if="customerSegmentDisplay">
                <label class="mb-3"><strong>{{ $translate('customer_segment')
                        }}</strong></label>
                <b-form-select id="input-customer-segment"
                    class="form-control" v-model="model.customer_segment_id"
                    value-field="id" text-field="name" :options="customerSegments">
                    <template #first>
                        <b-form-select-option :value="null">
                            {{ $translate('select_customer_segment') }}
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col md="6" cols="12" class="mt-3 dd" v-if="customerGroupDisplay">
                <label class="mb-3"><strong>{{ $translate('customer_group')
                        }}</strong></label>
                <b-form-select id="input-customer-group" class="form-control"
                    v-model="model.customer_group_id" value-field="id" text-field="name"
                    :options="customerGroups">
                    <template #first>
                        <b-form-select-option :value="null">
                            {{ $translate('select_customer_group') }}
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col md="6" cols="12" class="my-3 dd" v-if="customerAgentDisplay">
                <label class="mb-3"><strong>{{ $translate('customer_agent')
                        }}</strong></label>
                <b-form-select id="input-customer-agent"
                    class="form-control" v-model="model.customer_agent_id" value-field="id"
                    text-field="agent_name" :options="customerAgents">
                    <template #first>
                        <b-form-select-option :value="null">
                            {{ $translate('select_customer_agent') }}
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <!-- <b-col md="6" cols="12" class="my-3 dd">
                <label class="mb-3"><strong>{{ $translate('lifecycle_stage')
                        }}</strong></label>
                <b-form-select id="input-lifecycle-stage"
                    class="form-control" v-model="formData.customer.lifecycle_stage_id" value-field="id"
                    text-field="name" :options="lifecycleStages">
                    <template #first>
                        <b-form-select-option :value="null">
                            {{ $translate('select_lifecycle_stage') }}
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col> -->
        </b-row>
        <b-col class="w-100 mt-4">
            <AdditionalFieldsWrapper v-if="formData.customer" 
                :is-view="false"
                v-model="model.additional_fields" 
                :model-key="'model'" :item-type="'customer'"
                :cols-attr="6" 
                :modelable-id="0" 
                :modelable-type="'App\\Models\\Customer'"
                :key="'customer-onboard-additional-fields-' + formData.customer?.id"
                :context-id="'customer-onboard-additional-fields-' + formData.customer?.id" @loading="loading = $event">
            </AdditionalFieldsWrapper>
        </b-col>

        <b-col class="mt-5 text-left">
            <b-button type="submit" @click="prevStep()" class="btn btn-info btn-sm me-2">
                {{ $translate('previous') }}
            </b-button>
            <b-button type="submit" @click="submitForm()" :disabled="submitting ? true : false"
                class="btn btn-sm text-white px-3 py-2 me-2"
                style="background-color: #0080FF !important; border: none;">
                {{ $translate('finish') }}
            </b-button>
            <!-- <b-button type="submit" 
                class="btn btn-info btn-fw me-2 " variant="primary">{{ submitLabel }}</b-button> -->
        </b-col>
    </div>
</template>
<script>
import moment from 'moment'
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'
import AdditionalFieldsWrapper from '@/components/AdditionalFieldsWrapper.vue'

const userModel = Object.freeze({
    first_name: null,
    last_name: null,
    is_blacklisted: 1,
    portal_role_id: null,
    portal_access: null,
    email: null,
    phone: null,
    id: null,
    remarks: null,
})
export default {
    name: 'customerUsers-additionalInfo',
    mixins: [popupMixins, permissionsMixins],
    components: {
        AdditionalFieldsWrapper,
    },
    data() {
        return {
            // submitting: false,
            isDisabled: false,
            loading: false,
            hasErrors: false,

        }
    },
    props: ['value', 'submitting', 'themeColor', 'formData'],
    computed: {
        dobCalender() {
            return moment().subtract(18, 'years').format('YYYY-MM-DD')
        },
        customColor() {
            const data = this.$store.state.company.settings || {}
            const colors = {
                'background-color': data.background_color + "!important",
                color: data.text_color + "!important"
            }
            return colors
        },
        fields() {
            const { dummyEmailSuffix, getroleName } = this
            return [
                { label: '', key: 'actions' },
                { label: this.$translate('first_name'), key: 'first_name' },
                { label: this.$translate('last_name'), key: 'last_name' },
                {
                    key: 'email',
                    label: this.$translate('email'),
                    formatter: value =>
                        (value || '').indexOf(dummyEmailSuffix) >= 0
                            ? ''
                            : value,
                },
                {
                    key: 'portal_access',
                    label: this.$translate('role'),
                    formatter: value => getroleName(value)
                },
                { label: this.$translate('phone'), key: 'phone' },
            ]
        },
        
        customerSegments() {
            return this.$store.state.customerSegments.customer_segments
        },
        // lifecycleStages() {
        //     return this.$store.state.lifecycleStage.items
        // },
        customerGroups() {
            return this.$store.state.customerGroups.customer_groups
        },
        customerAgents() {
            return this.$store.state.customerAgents.customer_agents
        },

        is_blacklisted: {
            set(value) {
                this.$set(this.userModel, 'is_blacklisted', value ? 1 : 0)
            },
            get() {
                return this.isDummyEmail
                    ? true
                    : !!this.userModel.is_blacklisted
            },
        },
        displayEmail: {
            set(value) {
                this.$set(this.userModel, 'email', value)
            },
            get() {
                const {
                    isDummyEmail,
                    userModel: { email },
                    isEmailViewOnly,
                } = this
                return isDummyEmail && isEmailViewOnly
                    ? ''
                    : isDummyEmail
                        ? '------'
                        : email
            },
        },
        submitLabel() {
            if (this.submitting) {
                console.log()
                return this.$translate('submitting')
            } else {
                return this.$translate('finish')
            }
        },
        customerSubmitLabel() {
            if (this.loading && this.userModel.hash) {
                return this.$translate('updating')
            } else if (this.loading) {
                return this.$translate('creating')
            } else if (this.userModel.hash) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },
        isDummyEmail() {
            return (
                (this.userModel.email || '').indexOf(this.dummyEmailSuffix) >= 0
            )
        },
        model: {
            get() {
                console.log('', this.value)
                return this.value
            },
            set(value) {
                this.$emit('input', value) // Emit the Boolean value to control modal visibility
            },
        },
        contacts() {
            return this.$store.state.customers.items
        },
        customerSegmentDisplay() {
            const data = !!((this.$store.getters['company/configurations'] || []).find(x => x.key == 'customer_segment_display_on_customer_onboard')?.bool_value)
            return data
        },
        customerGroupDisplay() {
            console.log("this.$store.getters['company/configurations']", this.$store.getters['company/configurations'])
            const data = !!((this.$store.getters['company/configurations'] || []).find(x => x.key == 'customer_group_display_on_customer_onboard')?.bool_value)
            return data
        },
        customerAgentDisplay() {
            const data = !!((this.$store.getters['company/configurations'] || []).find(x => x.key == 'customer_agent_display_on_customer_onboard')?.bool_value)
            return data
        },
    },
    watch: {
        contacts: {
            immediate: true,
            handler: function () {

            },
            deep: true,
        },
        'userModel.portal_access': function (val) {
            this.$set(this.userModel, 'portal_role_id', val)
        },
    },
    created() {

        Promise.all([
            this.$store.dispatch('customerSegments/fetchAll'),
            // this.$store.dispatch('lifecycleStage/fetchAll'),
            this.$store.dispatch('customerGroups/fetchAll'),
            this.$store.dispatch('customerAgents/fetchAll'),
        ])
    },
    methods: {
        getroleName(role_id) {
            const roleData = this.portalAccess.find(x => x.id == role_id)
            return roleData?.name
        },
        viewCustomer(data, index) {
            console.log("index", index)
            if (index == 0) {
                this.isDisabled = true
            } else if (this.contacts.length == 0) {
                this.isDisabled = true
            } else {
                this.isDisabled = false
            }
            this.userModel = { ...userModel, ...(data || {}) }
            this.$bvModal.show('modal-customer-user')
        },
        checkFormValidity() {
            const valid = this.$refs.contactForm.checkValidity()
            return valid
        },
        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            ///this.handleSubmit()
            this.$refs.contactForm.requestSubmit()
        },
        submitForm() {
            this.$emit('submitForm'); // Emit the custom event
        },
        prevStep() {
            this.$emit('prev-clicked'); // Emit the custom event
        },
        deleteUser(hash) {
            const title = this.$translate('delete_customer')
            const message = `${this.$translate('delete_note')} ${this.$translate("customer")}?`

            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store.dispatch('customers/deleteContact', hash)
                    this.doToast(this.$translate('user_delete_alert'), this.$translate('deleted'), 'danger')
                    this.$bvModal.hide('modal-customer-user')
                }
            })
        },
        async handleSubmit() {
            try {
                if (!this.checkFormValidity()) {
                    throw new Error('Not Validated!')
                }
                await this.$set(this.userModel, 'portal_role_id', this.userModel.portal_access)
                const {
                    userModel: data,
                    isDummyEmail,
                    isEmailViewOnly,
                } = this
                const isNew = !data.hash
                console.log('dataaaa', this.customer)

                if (isEmailViewOnly) {
                    const { id: userId, email } = data
                    await this.$store.dispatch('users/updateEmail', {
                        userId,
                        email,
                    })
                    await this.$store.dispatch(
                        'customers/fetchById',

                    )
                } else {
                    if (isDummyEmail) {
                        data.is_blacklisted = 1
                    }

                    console.log('data', data)
                    if (data.is_blacklisted && !data.email) {
                        data.email = this.calculateDummyEmailAddress()
                    }
                    const path = `customers/merge`
                    this.loading = true
                    await this.$store.dispatch(path, {
                        data,
                    })
                }

                if (isNew) {
                    this.doToast(this.$translate('created'), this.$translate('user_create_alert'), 'success')
                } else {
                    this.doToast(this.$translate('updated'), this.$translate('user_update_alert'), 'success')
                }

                this.$nextTick(() => {
                    this.$bvModal.hide('modal-customer-user')
                })
            } catch (error) {
                const emailError = this.$translate('data_was_invalid')
                if (error.response) {
                    // Request made and server responded
                    console.log('error.response')
                    console.log(error.response.data)
                    console.log(error.response.status)
                    console.log(error.response.headers)
                    this.doToast(
                        this.$translate('error'),
                        error.response.data.message,
                        'danger'
                    )
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log('error.request')
                    console.log(error.request)
                    this.doToast(
                        this.$translate('system_error_detected'),
                        this.$translate('contact_administrator'),
                        'danger'
                    )
                } else {
                    // Something happened in setting up the request that triggered an Error
                    let errorMessage = error.message

                    if (errorMessage == emailError) {
                        errorMessage = this.$translate('email_already_used')
                    }
                    console.log('Error', error.message)
                    this.doToast(this.$translate('error'), errorMessage, 'danger')
                }
            } finally {
                this.loading = false
            }
        },
        calculateDummyEmailAddress() {
            const username =
                Math.random().toString(36).substring(2, 15) +
                Math.random().toString(36).substring(2, 15)
            return `${username}-${this.dummyEmailSuffix}`
        },

        delete_all_user() {
            this.$bvModal.show('modal-delete')
        },
        delete_users() {
            if (this.selectedItems.length > 0) {

                this.selectedItems.forEach(item => {

                    const hash = item.hash;


                    this.$store.dispatch('customers/deleteContact', hash)
                        .then(() => {

                            // Optionally, remove the item from selectedItems after deletion
                            const index = this.selectedItems.indexOf(item);
                            if (index !== -1) {
                                this.selectedItems.splice(index, 1);
                            }
                        })
                        .catch(err => {

                            this.doToast(this.$translate('error'), err, 'danger')
                            console.error('Error deleting contact:', err);
                        });
                });
                this.$bvModal.hide('modal-delete')
                this.doToast(this.$translate('user_delete_alert'), this.$translate('deleted'), 'danger')
            } else {

                let errorMessage = "No users selected for deletion";
                this.doToast(this.$translate('error'), errorMessage, 'danger')
                console.log('No items selected for deletion');
            }
        },
        onCheckboxChange(item) {
            // If the item is selected, add it to the selectedItems array
            if (item.selected) {
                if (!this.selectedItems.includes(item)) {
                    this.selectedItems.push(item);
                }
            } else {
                // If the item is deselected, remove it from the selectedItems array
                const index = this.selectedItems.indexOf(item);
                if (index !== -1) {
                    this.selectedItems.splice(index, 1);
                }
            }
            console.log('Selected Items:', this.selectedItems);
        }
    },
}
</script>
<style></style>
